import { useState } from "react";
import { FileText } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Card, CardDescription, CardContent } from "@/components/ui/card";

const data = [
  {
    title: "Submit Offer",
    description: "Follow the steps below to submit an offer as a seller agent.",
    items: [
      {
        title: "Steps",
        text: "To submit an offer, enter the client's email (required) and other details. Make sure there is an existing client account with this email, or you can create a new account for that client from Register Client page.",
        image: "Submit Offer.png",
      },
    ],
  },
  {
    title: "Request Material",
    description:
      "Follow the steps below to request a material as a buyer agent.",
    items: [
      {
        title: "Steps",
        text: "To request a material, enter the client's email (required) and other details. Make sure there is an existing client account with this email, or you can create a new account for that client from Register Client page.",
        image: "Request Material.png",
      },
    ],
  },
  {
    title: "Manage Request",
    description:
      "To manage incoming requests - including approval, rejection, escalation, or product information review. Follow the outlined steps for seamless request processing.",
    items: [
      {
        title: "Actions",
        text: "Approve, reject, or escalate a request.",
        image: "Manage Request.png",
      },
      {
        title: "View Product",
        text: "View product information of a request.",
        image: "View Product.png",
      },
    ],
  },
  {
    title: "Register Client",
    description:
      "Follow the steps below to register a client on JP Associates platform.",
    items: [
      {
        title: "Steps",
        text: "Fill in the details to create a buyer/seller account for the client.",
        image: "Register Client.png",
      },
    ],
  },
];

const Documentation = () => {
  const [activeItem, setActiveItem] = useState(data[0]);

  const handleClick = (link) => {
    setActiveItem(link);
  };

  const renderContent = () => {
    if (!activeItem) return null;

    return (
      <Card>
        <CardContent>
          <CardDescription>
            <div className="font-bold text-lg mt-6 mb-3">
              {activeItem.title}
            </div>

            <div>{activeItem.description}</div>

            {activeItem?.items?.map((item, i) => (
              <div key={i} className="mt-4">
                <div className="font-bold mb-2">{item.title}</div>
                <div>{item?.text}</div>
                <img
                  alt={item.title}
                  className="mt-4 rounded-lg border-2 border-gray-200"
                  src={require(`../../assets/documentation/${item.image}`)}
                />
              </div>
            ))}
          </CardDescription>
        </CardContent>
      </Card>
    );
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Main content */}
      <div className="flex-1 flex flex-col">
        <Separator />

        <div className="flex flex-1 overflow-hidden">
          {/* Main documentation content */}
          <main className="flex-1 overflow-y-auto p-6">
            <h1 className="text-lg font-bold mb-4 ml-0.5">Documentation</h1>

            <div>{renderContent()}</div>
          </main>

          {/* Right sidebar - table of contents */}
          <aside className="w-64 bg-white border-l hidden lg:block p-6 overflow-y-auto">
            <h3 className="font-semibold text-gray-800 mt-1 mb-4">
              On this page
            </h3>
            <ul className="space-y-3">
              {data.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => handleClick(link)}
                    className={`flex items-center justify-start ${
                      activeItem === link ? "text-blue-600" : "text-gray-600"
                    } hover:text-blue-600`}
                  >
                    <FileText className="mr-2" size={16} />
                    <span className="text-sm">{link.title}</span>
                  </button>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default Documentation;
